export interface CountryPhone {
  iso2: string;
  dialCode: string;
  name: string;
  flag: string;
}

export const COUNTRIES_PHONES_JSON_URL = 'assets/data/countries-phones.json';

export const DIAL_CODE_DEFAULT_COUNTRY: Record<string, string> = {
  '1': 'US',
};
